<template>
  <div>
    <div
      class="flex flex-wrap mb-4"
      v-if="selected.length != 0"
    >
      <div  v-for="(selected, index) in selected"
        :key="index">
      
        <div class="text-center mr-1">
          <div class="selected-names">
            <img class="img-fluid" style="border-radius: 100%; object-fit: contain;" v-if="selected.picture" :src="selected.picture" />
            <img class="img-fluid" style="border-radius: 100%; object-fit: contain;" v-else src="http://scoolio-dev.track-progress.com/img/user-circle-solid.c3580913.svg" alt="">

            <span class="close"
            @click="removeSelected(selected.id,index)"
            >&times;</span>
          </div>
          <p class="name-selected">
            {{ selected.name }} 
          </p>
        </div>
      </div>
    </div>
    <!-- <pre>{{clientsListInvoices}}</pre> -->
    <vx-card title="Search View" class="mb-4"
    v-if="!payPopup"
    >
      <vs-row>
        <vs-col class="lg:pr-1 pr-0 sm:p-1 p-0" vs-lg="8" vs-sm="12">
          <!--  <pre>{{ paymentOption }}</pre>
            {{paymentType}} -->
            <v-select
              class="w-full"
              placeholder="Payment Frequency"
              :options="paymentOption"
              v-model="paymentType"
              :reduce="item=>item.id"
              label="text"
            ></v-select>
        </vs-col>
        <vs-col class="lg:pl-1 pl-0 sm:p-1 p-0 lg:text-right text-left" vs-lg="4" vs-sm="12">
          <!-- <vs-button :disabled="!paymentType">Next</vs-button> -->
          <vs-button class="ml-2" @click="payPopup = true" v-if="checkingDataAndUser">Proceed</vs-button>
        </vs-col>
      </vs-row>
        <!-- <div class="p-1 filter-holder-col">
          <date-range-picker
            ref="picker"
            class="w-full"
            :locale-data="{ firstDay: 1, format: 'DD-MM-YYYY HH:mm:ss' }"
            :showWeekNumbers="true"
            :showDropdowns="true"
            :autoApply="true"
            v-model="dateRange"
          >
            <template v-slot:input="picker" style="min-width: 350px">
              {{ picker.startDate | date }} - {{ picker.endDate | date }}
            </template>
          </date-range-picker>
        </div> -->
    </vx-card>

    <!-- <vs-button 
    @click="payPopup = true"
    v-if="checkingDataAndUser"
    >Pay</vs-button> -->
    <!-- {{checkingDataAndUser}} -->
    <!-- {{selected}} -->
    <!-- {{staffList}} -->
    
    <vs-table
        v-if="!payPopup"

      class="cstm_vuexy_table"
      multiple
      v-model="selected"
      :data="staffList"
    >
      <template slot="thead">
        <vs-th> Name </vs-th>
        <vs-th> Email </vs-th>
                <vs-th> Phone </vs-th>

     
      </template>

      <template slot-scope="{ data }">
        <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data">
          <vs-td :data="data[indextr].name">
            <div class="flex items-center">
              <!-- <pre>{{data[indextr]}}</pre> -->
              <img
                style="width: 40px; height: 40px"
                class="rounded-full shadow-md block mr-2"
                v-if="data[indextr].picture"
                :src="data[indextr].picture"
                alt="image"
              />
              <img
                style="width: 40px; height: 40px"
                class="rounded-full shadow-md block mr-2"
                v-else
                src="http://cx-lms-api-dev.track-progress.com/staticAsset/emoticons/user_image.png"
                alt="image"
              />
              {{ data[indextr].name }}
            </div>
          </vs-td>

         
          <vs-td>
            <span v-if="data[indextr]">
           {{data[indextr].email}}
           </span>
          </vs-td>

          <vs-td>
            <span v-if="data[indextr]">
           {{data[indextr].phone}}
           </span>
          </vs-td>

       <!--    <vs-td class="payment-holder">
            <p class="ml-1">{{ data[indextr].payment_mode }}</p>
          </vs-td> -->
        </vs-tr>
      </template>
    </vs-table>
    <!-- {{meta}} -->
    <pagination :meta="meta" @page-change="handlePageChange" class="ml-auto" 
        v-if="!payPopup"

    />
    <!-- <div
      class="vs-component con-vs-popup vs-popup-primary cstm-modal-popup schedule-popup"
      v-if="payPopup"
      :class="{ show: payPopup }"
    > -->
      <div 
          v-if="payPopup"

      >
      <!-- <vs-button icon="chevron_left" type="border" @click="payPopup = false"></vs-button> -->
        <!-- <div class="header">
          <h4>Pay</h4>
          <button @click="payPopup = false" class="close-modal">&times;</button>
        </div> -->
        <div class="modal-content">
          <label>Select Date Range</label>
         <date-range-picker
            ref="picker"
            class="w-full pay_date_picker"
            :locale-data="{ firstDay: 1, format: 'DD-MM-YYYY HH:mm:ss' }"
            :showWeekNumbers="true"
            :showDropdowns="true"
            :autoApply="true"
            v-model="dateRange"
            :ranges="customDateRanges()"
          >
            <template v-slot:input="picker" style="min-width: 350px">
              {{ picker.startDate | date }} - {{ picker.endDate | date }}
            </template>
          </date-range-picker>
         <pay-range
         @closePayrange="closePayrange"
         v-if="dateRange"
         :users="selectedusersId"
         :dateRange="dateRange"
         ></pay-range>
        </div>
      <!-- </div> -->
    </div>
  </div>
</template>

<script>
import { FinanceMixin } from '../mixins/FinanceMixin'
import DateRangePicker from 'vue2-daterange-picker'
import 'vue2-daterange-picker/dist/vue2-daterange-picker.css'
import vSelect from 'vue-select'
import Pagination from '@/components/common/pagination'
import { getStaffUserList} from '@/api/finance'
import PayRange from './PayRange'
export default {
  mixins: [FinanceMixin],
  components: {
    DateRangePicker,
    vSelect,
    Pagination,
    PayRange
  },
  watch:{
    paymentType () {
      this.getStaffUserList()
      
    }
  },
  created () {
    this.getStaffUserList()
    // this.fetchCLientFinance(1)
  },
  data () {
    return {
      meta: {
        current_page: 1,
        has_next: true,
        limit: 10,
        next_page_url: '',
        previous_page_url: null,
        total: null
      },
      query_page: {
        page: 1
      },
      paymentType: null,
      paymentOption: [
        { text: 'Weekly', id: 1 },
        { text: 'Monthly', id: 2 }
      ],
      dateRange: {},
      payPopup: false,
      payStaff: [
        {
          id: 1,
          s_name: 'Shakhadeepa Bhattacharjee',
          pay_freq: 'Weekly',
          guar_work_hour: 10,
          total_hour: 80,
          hour_pay: 50,
          total_pay: 4000,
          pay_duration: 1
        },
        {
          id: 2,
          s_name: 'Yasin Bhai',
          pay_freq: 'Weekly',
          guar_work_hour: 10,
          total_hour: 80,
          hour_pay: 50,
          total_pay: 4000,
          pay_duration: 1
        }
      ],
      staffList:[]
    }
  },
  computed:{
    selectedusersId () {
      return this.selected.map(ele => {
        return ele.id
      })
    },
    // checkingDataAndUser () {
    //   return this.selected.length && 'startDate' in this.dateRange
    // }
    checkingDataAndUser () {
      return this.selected.length
    }
  },
  methods: {
    removeSelected (id, index) {    
      
      this.selected.splice(index, 1)
    },
    handlePageChange (page) {
      this.meta.current_page = page
      this.getStaffUserList()
    },
    genInvoice (id) {
      this.$router.push({
        name: 'invoice-preview',
        params: {
          invoiceSidebarData: id
        }
      })
    },
    closePayrange (checking) {
      if (checking !== 'back') {
        this.$emit('afterPaid')
      }
      this.payPopup = false
    },
    /*   async getPayoutUserList () {

      try {
        const customer_id = parseInt(localStorage.getItem('customer_id'))
        const payload = {
          payment_frequency : this.paymentType
        }
        const {data} = await getPayoutUserListApi(customer_id, payload)
        console.log(data)
        this.staffList = data.data.users
        this.meta = data.data.meta
        console.log(data)
      } catch (error) {
        console.log(error)
      }
    }, */
    async getStaffUserList () {
      try {
        const customer_id = parseInt(localStorage.getItem('customer_id'))
        const payload = {
          payment_frequency : this.paymentType
        }
        const {data} = await getStaffUserList(customer_id, payload, this.meta.current_page)
        console.log(data)
        this.staffList = data.data.users
        this.meta = data.data.meta
        console.log(data)
      } catch (error) {
        console.log(error)
      }
    }
  }
}
</script>

<style>
.pay_date_picker .daterangepicker.openscenter {
  left: 0;
  transform: translateX(0);
}
</style>